import PropTypes from "prop-types";
import { forwardRef } from "react";
import { Link as RouterLink } from "react-router-dom";
// @mui
import { useTheme } from "@mui/material/styles";
import { Box, Link, Typography } from "@mui/material";
import { PATH_HOMEPAGE } from "../../routes/paths";

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, ...other }, ref) => {
  // OR using local (public folder)
  // -------------------------------------------------------
  const logo = (
    <Box
      // component={RouterLink}
      to="/"
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        // width: 132,
        // padding: "20px 0",
        textDecoration: "none",
        cursor: "pointer",
        ...sx,
      }}
    >
      <Box
        component="img"
        src="/logo/an-logo.png"
        sx={{
          width: 135,
          // height: 28,
          // objectFit: "contain",
        }}
      />
      {/*<Typography*/}
      {/*  sx={{*/}
      {/*    fontSize: 22,*/}
      {/*    fontWeight: 400,*/}
      {/*    color: "#181B1E",*/}
      {/*    lineHeight: 1,*/}
      {/*      textTransform: "lowercase"*/}
      {/*  }}*/}
      {/*>*/}
      {/*  ANOMICA*/}
      {/*</Typography>*/}
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return (
    <Link
      to="/"
      rel="noopener"
      component={RouterLink}
      sx={{ display: "contents" }}
    >
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
};

export default Logo;
